import { formatDateTime } from '../../../utils/date-format'
import { buildCell, buildMainHeaderCell, buildProjectName, buildReportDate, buildSubHeaderCell } from '../report-utils'
import { formatMoney } from '../../../utils/number-utils'

const ExcelJS = require('exceljs')
const FileSaver = require('file-saver')

const mergeRowCells = (worksheet, colIdx, rowIdxStart, rowIdxEnd) =>
  worksheet.mergeCells(rowIdxStart, colIdx, rowIdxEnd - 1, colIdx)

const buildHeader = (worksheet, start = 1) => {
  buildMainHeaderCell(worksheet, 1, 3, 'Заявка', start)
  buildSubHeaderCell(worksheet, 1, 'Проект', 30, start)
  buildSubHeaderCell(worksheet, 2, 'Ид заявки', 15, start)
  buildSubHeaderCell(worksheet, 3, 'Дата заявки', 20, start)

  buildMainHeaderCell(worksheet, 4, 7, 'Смета', start)
  buildSubHeaderCell(worksheet, 4, 'Наименование из сметы', 50, start)
  buildSubHeaderCell(worksheet, 5, 'Количество', 15, start)
  buildSubHeaderCell(worksheet, 6, 'Ед. измерения', 20, start)
  buildSubHeaderCell(worksheet, 7, 'Цена из сметы', 20, start)

  buildMainHeaderCell(worksheet, 8, 11, 'Поиск', start)
  buildSubHeaderCell(worksheet, 8, 'Наименование продукта', 50, start)
  buildSubHeaderCell(worksheet, 9, 'Актуальная цена', 30, start)
  buildSubHeaderCell(worksheet, 10, 'Продавец', 20, start)
  buildSubHeaderCell(worksheet, 11, 'Ссылка на товар', 60, start)
}

const exportToXLS = async (data, project, sheetName = 'Отчет') => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  buildReportDate(worksheet, 2)
  project && buildProjectName(worksheet, project, 4)

  const start = 6

  buildHeader(worksheet, start)

  data.reduce((nextIndex, item, index) => {
    const {
      appRowSpan,
      appItemRowSpan,
      projectName,
      appId,
      appCreateDate,
      estimateFieldName,
      appItemAmount,
      estimateFieldUnit,
      estimateFieldPrice,
      webSearchFieldProductName,
      webSearchFieldPrice,
      webSearchFieldSource,
      webSearchFieldUrl,
    } = item

    if (appRowSpan) {
      mergeRowCells(worksheet, 1, nextIndex, nextIndex + appRowSpan)
      buildCell(worksheet, projectName, 1, nextIndex)

      mergeRowCells(worksheet, 2, nextIndex, nextIndex + appRowSpan)
      buildCell(worksheet, appId, 2, nextIndex)

      mergeRowCells(worksheet, 3, nextIndex, nextIndex + appRowSpan)
      buildCell(worksheet, formatDateTime(appCreateDate), 3, nextIndex)
    }

    if (appItemRowSpan) {
      mergeRowCells(worksheet, 4, nextIndex, nextIndex + appItemRowSpan)
      buildCell(worksheet, estimateFieldName, 4, nextIndex)

      mergeRowCells(worksheet, 5, nextIndex, nextIndex + appItemRowSpan)
      buildCell(worksheet, appItemAmount, 5, nextIndex)

      mergeRowCells(worksheet, 6, nextIndex, nextIndex + appItemRowSpan)
      buildCell(worksheet, estimateFieldUnit, 6, nextIndex)

      mergeRowCells(worksheet, 7, nextIndex, nextIndex + appItemRowSpan)
      buildCell(worksheet, formatMoney(estimateFieldPrice), 7, nextIndex)
    }

    buildCell(worksheet, webSearchFieldProductName, 8, nextIndex)
    buildCell(worksheet, formatMoney(webSearchFieldPrice), 9, nextIndex)
    buildCell(worksheet, webSearchFieldSource, 10, nextIndex)
    buildCell(worksheet, webSearchFieldUrl, 11, nextIndex)

    return nextIndex + 1
  }, start + 2)

  const buffer = await workbook.xlsx.writeBuffer()
  FileSaver.saveAs(new Blob([buffer]), 'web_search_report.xlsx')
}

export default exportToXLS
